import type { CreativeBlock } from "./types";

export function hasSquareCreativeSlot(creative: CreativeBlock): boolean {
  return Boolean(
    (creative.squareMediaUrl || creative.squareMediaFileKey) &&
      creative.squareMediaType
  );
}

export function hasVerticalCreativeSlot(creative: CreativeBlock): boolean {
  return Boolean(
    (creative.verticalMediaUrl || creative.verticalMediaFileKey) &&
      creative.verticalMediaType
  );
}

export function hasFacebookPage(creative: CreativeBlock): boolean {
  return Boolean(creative.fbPage?.id?.trim());
}

export function hasInstagramAccount(creative: CreativeBlock): boolean {
  return Boolean(creative.instagramAccount?.id?.trim());
}
